import { SignUpStage } from './interfaces';
import { createProxy } from '../../toolkit/proxy';
import { SignUpStrategyEnum } from '@frontegg/rest-api';
export const initialState = {
  loading: false,
  allowSignUps: false,
  allowNotVerifiedUsersLogin: false,
  firstLoad: true,
  stage: SignUpStage.SignUp,
  strategies: {
    [SignUpStrategyEnum.Email]: {
      enabled: true,
      required: true
    },
    [SignUpStrategyEnum.PhoneNumber]: {
      enabled: false,
      required: false
    }
  }
};
export default (overrideState => createProxy(initialState, overrideState));